var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isFullWidth
    ? _c(
        "div",
        { staticClass: "fixed-grid has-12-cols is-align-self-center" },
        [
          _c("div", { staticClass: "grid is-align-items-center" }, [
            _c("div", { staticClass: "cell is-col-span-6" }, [
              _c("div", { staticClass: "fixed-grid has-12-cols" }, [
                _c("div", { staticClass: "grid is-align-items-center" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "cell is-col-span-11 is-flex is-flex-direction-column",
                    },
                    [_vm._t("description")],
                    2
                  ),
                  _c(
                    "div",
                    { staticClass: "cell is-col-span-1 is-clickable" },
                    [_vm._t("report_blend")],
                    2
                  ),
                ]),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "cell is-col-span-2" },
              [_vm._t("sublet_type")],
              2
            ),
            _c(
              "div",
              { staticClass: "cell is-col-span-2" },
              [_vm._t("sublet_vendor")],
              2
            ),
            _c("div", { staticClass: "cell" }, [_vm._t("total_value")], 2),
            _c(
              "div",
              { staticClass: "cell end" },
              [
                _vm._t("comment"),
                _vm._t("assessment_status"),
                _vm._t("delete_button"),
                _vm._t("drag_handle"),
              ],
              2
            ),
          ]),
        ]
      )
    : _c(
        "div",
        { staticClass: "fixed-grid has-12-cols is-align-self-center" },
        [
          _c(
            "div",
            { staticClass: "grid", staticStyle: { "row-gap": "5px" } },
            [
              _c(
                "div",
                { staticClass: "cell is-col-span-6 is-align-self-center" },
                [_vm._t("description")],
                2
              ),
              _c(
                "div",
                { staticClass: "cell is-flex is-justify-content-end" },
                [_vm._t("report_blend")],
                2
              ),
              _c("div", { staticClass: "cell is-col-span-1" }),
              _c(
                "div",
                { staticClass: "cell is-col-span-4 is-align-content-center" },
                [
                  _c("div", { staticClass: "fixed-grid has-12-cols" }, [
                    _c("div", { staticClass: "grid is-align-items-center" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "cell is-col-span-5 is-align-self-center",
                        },
                        [_vm._t("total_value")],
                        2
                      ),
                      _c(
                        "div",
                        { staticClass: "cell is-col-span-7 end" },
                        [
                          _vm._t("comment"),
                          _vm._t("assessment_status"),
                          _vm._t("delete_button"),
                          _vm._t("drag_handle"),
                        ],
                        2
                      ),
                    ]),
                  ]),
                ]
              ),
              _vm.isFullyExpanded
                ? _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: { content: "Sublet Type" },
                          expression: "{ content: 'Sublet Type' }",
                        },
                      ],
                      staticClass: "cell is-col-span-3",
                    },
                    [_vm._t("sublet_type")],
                    2
                  )
                : _vm._e(),
              _vm.isFullyExpanded
                ? _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: { content: "Vendor" },
                          expression: "{ content: 'Vendor' }",
                        },
                      ],
                      staticClass: "cell is-col-span-3",
                    },
                    [_vm._t("sublet_vendor")],
                    2
                  )
                : _vm._e(),
              _vm.isFullyExpanded
                ? _c("div", { staticClass: "cell is-col-span-6" })
                : _vm._e(),
              _vm.isFullyExpanded && _vm.isSupportUser
                ? _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: { content: "Line Number" },
                          expression: "{ content: 'Line Number' }",
                        },
                      ],
                      staticClass: "cell is-col-span-2",
                    },
                    [_vm._t("lineNo")],
                    2
                  )
                : _vm._e(),
              _vm.isFullyExpanded && _vm.isSupportUser
                ? _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: { content: "Item Number" },
                          expression: "{ content: 'Item Number' }",
                        },
                      ],
                      staticClass: "cell is-col-span-2",
                    },
                    [_vm._t("itemNo")],
                    2
                  )
                : _vm._e(),
              _vm.isFullyExpanded && _vm.isSupportUser
                ? _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: { content: "Item Status" },
                          expression: "{ content: 'Item Status' }",
                        },
                      ],
                      staticClass: "cell is-col-span-2",
                    },
                    [_vm._t("itemStatus")],
                    2
                  )
                : _vm._e(),
            ]
          ),
        ]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }